import React, { useState, useEffect } from "react";

import axios from "axios";
import {
    Pagination,
    Container,
    Row,
    Col,
    Form,
    Button,
    Table,
    Card,
    Accordion,
    Alert,
    Tabs,
    Tab,
} from "react-bootstrap";
const BASE_URL = "https://drdprints.com/api";
const ProductsPage = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10); // Number of products per page
    const [filterCategory, setFilterCategory] = useState("");
    const [types, setTypes] = useState([]);
    const [products, setProducts] = useState([]);
    const [productData, setProductData] = useState({
        title: "",
        desc: "",
        image: null,
        pd_short_desc: "",
        pd_overview_title: "",
        pd_overview_desc: "",
        pd_overview_image: null,
        pd_image_color_id: "",
        pd_images: [],
        pd_size_title: [],
        pd_size_desc: [],
        pd_size_s: [],
        pd_size_l: [],
        pd_size_xl: [],
        pd_size_2xl: [],
        pd_size_3xl: [],
        pd_prices: [],
        faq_title: [],
        faq_desc: [],
        product_category_id: "",
        product_subcategory_id: "",
        product_BusinessTool_id: "",
        product_sub_main_cat: "",
        product_deal_id: "",
        product_type: "", // New field for product type
    });

    const [filteredProducts, setFilteredProducts] = useState([]);
    const [selectedCategoryId, setSelectedCategoryId] = useState("");
    const [selectedProductId, setSelectedProductId] = useState(null);
    const [message, setMessage] = useState(null);
    const [key, setKey] = useState("general");
    const [categories, setCategories] = useState([]);
    const [subcategories, setSubCategories] = useState([]);
    const [deals, setDeals] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [productDetails, setProductDetails] = useState(null);
    const [businessCards, setBusinessCards] = useState([]);
    const [Colors, setColors] = useState([]);

    const [subMainCategories, setSubMainCategories] = useState([]);

    useEffect(() => {
        if (productData.product_sub_main_cat) {
            const filteredSubCategories = subMainCategories.filter((subMainCat) => subMainCat.id === parseInt(productData.product_sub_main_cat))
            setSubCategories(filteredSubCategories);
        } else {
            setSubCategories([]); // Clear subcategories if no sub-main category is selected
        }
    }, [productData.product_sub_main_cat, categories]);

    const fetchTypes = async () => {
        try {
            const response = await axios.get("https://drdprints.com/api/get-types");
            setTypes(response.data.types || []);
        } catch (error) {
            console.error("Error fetching product types:", error);
        }
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const totalPages = Math.ceil(filteredProducts.length / pageSize);

    const paginatedProducts = filteredProducts.slice(
        (currentPage - 1) * pageSize,
        currentPage * pageSize
    );

    useEffect(() => {
        fetchTypes();
        fetchCategories();
        fetchDeals();
        fetchProductsList();
        fetchSubMainCategories();
    }, []);
    useEffect(() => {
        fetchBusinessCards();
        fetchColors();
    }, []);

    // Fetch business cards from the API
    const fetchBusinessCards = async () => {
        try {
            const response = await axios.get(
                "https://drdprints.com/api/get-productbusinesscards"
            );
            setBusinessCards(response.data.product_business_cards);
        } catch (error) {
            console.error("Error fetching business cards:", error);
        }
    };

    const fetchColors = async () => {
        try {
            const response = await axios.get(
                "https://drdprints.com/api/get-productcolors"
            );
            setColors(response.data.productcolors);
        } catch (error) {
            console.error("Error fetching colors:", error);
        }
    };

    const fetchProductDetailsById = async (product) => {
        if (!product || !product.slug) {
            console.error("Invalid product or slug not provided");
            setMessage({ type: "danger", text: "Product slug not provided." });
            return;
        }

        try {
            const response = await axios.get(`https://drdprints.com${product.slug}`);
            const fetchedProduct = response.data;
            console.log(fetchedProduct)

            // Update productData for editing purposes
            setProductData({
                ...productData,
                title: fetchedProduct.product || "",
                desc: fetchedProduct.product_details[0]?.pd_short_desc || "",
                image: fetchedProduct.product_images[0]?.pd_image || null,
                pd_short_desc: fetchedProduct.product_details[0]?.pd_short_desc || "",
                pd_overview_title: fetchedProduct.product_details[0]?.pd_overview_title || "",
                pd_overview_desc: fetchedProduct.product_details[0]?.pd_overview_desc || "",
                pd_overview_image: fetchedProduct.product_details[0]?.pd_overview_image || null,
                pd_image_color_id: fetchedProduct.product_images[0]?.color_id || "",
                pd_images: fetchedProduct.product_images.map((img) => img.pd_image) || [],
                pd_prices: fetchedProduct.product_prices.map((price) => price.price) || [],
                faq_title: fetchedProduct.product_faqs.map((faq) => faq.pd_faq_title) || [],
                faq_desc: fetchedProduct.product_faqs.map((faq) => faq.pd_faq_desc) || [],
                pd_size_title: fetchedProduct.product_sizes.map((size) => size.pd_size_title) || [],
                pd_size_desc: fetchedProduct.product_sizes.map((size) => size.pd_size_desc) || [],
                pd_size_s: fetchedProduct.product_sizes.map((size) => size.pd_size_s) || [],
                pd_size_l: fetchedProduct.product_sizes.map((size) => size.pd_size_l) || [],
                pd_size_xl: fetchedProduct.product_sizes.map((size) => size.pd_size_xl) || [],
                pd_size_2xl: fetchedProduct.product_sizes.map((size) => size.pd_size_2xl) || [],
                pd_size_3xl: fetchedProduct.product_sizes.map((size) => size.pd_size_3xl) || [],
                product_category_id: fetchedProduct.product_category_id || "",
                product_sub_main_cat: fetchedProduct.product_sub_main_category || "",
                product_subcategory_id: fetchedProduct.product_sub_category || "",
                product_BusinessTool_id: fetchedProduct.product_business_card_id || "",
                product_deal_id: fetchedProduct.product_deal_id || "",
                product_type: "", // Add if product type info is included
            });

            // Update productDetails for displaying all data
            setProductDetails({
                product: fetchedProduct.product,
                category: fetchedProduct.product_category_name || "N/A",
                deal: fetchedProduct.product_deal_name || "N/A",
                deal_discount: fetchedProduct.product_deal_discount || "N/A",
                business_tool: fetchedProduct.product_business_card_name || "N/A",
                product_details: fetchedProduct.product_details,
                product_prices: fetchedProduct.product_prices,
                product_images: fetchedProduct.product_images,
                product_faqs: fetchedProduct.product_faqs,
                product_sizes: fetchedProduct.product_sizes,
                imagePath: fetchedProduct.imagePath,
            });

            setMessage({
                type: "success",
                text: `Product details for "${fetchedProduct.product}" loaded successfully.`,
            });
        } catch (error) {
            console.error("Error fetching product details:", error);
            setMessage({ type: "danger", text: "Failed to fetch product details." });
        }
    };
    // console.log('colors', Colors)

    const fetchSubMainCategories = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/get-sub-main-category`);
            setSubMainCategories(response.data.sub_main_categories);
        } catch (error) {
            console.error("Error fetching sub main categories:", error);
        }
    };

    // console.log("businessCards", businessCards);

    const createSlug = (name, id) => {
        const nameSlug = name
            .toLowerCase()
            .replace(/ /g, "-")
            .replace(/[^\w-]+/g, "");
        return `${nameSlug}-${id}`;
    };

    const processCategories = (data) => {
        const allSubCategories = [];

        data.categories.forEach((category) => {
            if (category.sub_categories) {
                category.sub_categories.forEach((subCategory) => {
                    allSubCategories.push({
                        id: subCategory.id,
                        title: subCategory.cat_sub_title,
                        image: subCategory.image,
                        parentCategory: category.cat_title,
                    });
                });
            }
        });
        return allSubCategories;
    }

    const fetchCategories = async () => {
        try {
            const response = await fetch("https://drdprints.com/api/get-category");
            const data = await response.json();
            setSubCategories(processCategories(data));
            setCategories(data.categories || []);
        } catch (error) {
            console.error("Error fetching categories:", error);
        }
    };

    const fetchSubCategories = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/get-all-subcategories`);
            // setSubCategories(response.data.sub_categories || []); // Set all subcategories
        } catch (error) {
            console.error("Error fetching subcategories:", error);
        }
    };

    const fetchDeals = async () => {
        try {
            const response = await axios.get(
                "https://drdprints.com/api/get-productdeals"
            );
            const data = response.data.productdeals || [];
            setDeals(data);
        } catch (error) {
            console.error("Error fetching deals:", error);
        }
    };

    const fetchProductsList = async () => {
        try {
            const response = await fetch("https://drdprints.com/api/get-products");
            const data = await response.json();
            setProducts(data.products || []);
            setFilteredProducts(data.products || []); // Initially display all products
        } catch (error) {
            console.error("Error fetching products:", error);
        }
    };

    const fetchProductDetails = async (slug) => {
        try {
            const response = await axios.get(`https://drdprints.com${slug}`);
            setProductDetails(response.data || null);
        } catch (error) {
            console.error("Error fetching product details:", error);
            setMessage({ type: "danger", text: "Failed to fetch product details" });
        }
    };

    const handleProductSelect = (slug) => {
        setSelectedProduct(slug);
        fetchProductDetails(slug);
    };

    const handleProductEdit = (product) => {
        setSelectedProductId(product.id);

        fetchProductDetailsById(product)
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    const saveProduct = async () => {
        const formData = new FormData();
        const payload = {
            ...productData,
            pd_size_title: productData.pd_size_title || [],
            pd_size_desc: productData.pd_size_desc || [],
            faq_title: productData.faq_title || [],
            faq_desc: productData.faq_desc || [],
            pd_prices: productData.pd_prices || [],
            pd_size_s: productData.pd_size_s || [],
            pd_size_l: productData.pd_size_l || [],
            pd_size_xl: productData.pd_size_xl || [],
            pd_size_2xl: productData.pd_size_2xl || [],
            pd_size_3xl: productData.pd_size_3xl || [],
            cat_id: productData.product_category_id || null,
            deal_id: productData.product_deal_id || null,
            sub_cat: productData.product_subcategory_id || null,
            b_card_id: productData.product_BusinessTool_id || null,
            sub_main_cat: productData.product_sub_main_cat || null,
            type: productData.product_type || null,
        };

        // Append array fields
        [
            "pd_size_title",
            "pd_size_desc",
            "faq_title",
            "faq_desc",
            "pd_prices",
            "pd_size_s",
            "pd_size_l",
            "pd_size_xl",
            "pd_size_2xl",
            "pd_size_3xl",
        ].forEach((key) => {
            if (Array.isArray(productData[key])) {
                productData[key].forEach((item, index) => {
                    formData.append(`${key}[${index}]`, item);
                });
            }
        });

        // Append images
        if (productData.pd_images.length > 0) {
            productData.pd_images.forEach((file, index) => {
                formData.append(`pd_images[${index}]`, file); // Append each file with a unique key
            });
        }
        // Handle single image fields
        if (productData.image) formData.append("image", productData.image);
        if (productData.pd_overview_image)
            formData.append("pd_overview_image", productData.pd_overview_image);

        // Append other non-array fields
        for (const key in productData) {
            if (
                !Array.isArray(productData[key]) &&
                productData[key] &&
                !["image", "pd_images", "pd_overview_image"].includes(key)
            ) {
                formData.append(key, productData[key]);
            }
        }

        // Append specific ID fields
        if (productData.product_category_id) {
            formData.append("cat_id", productData.product_category_id);
        }

        if (productData.product_deal_id) {
            formData.append("deal_id", productData.product_deal_id);
        }

        if (productData.product_subcategory_id) {
            formData.append("sub_cat", productData.product_subcategory_id);
        }

        if (productData.product_BusinessTool_id) {
            formData.append("b_card_id", productData.product_BusinessTool_id);
        }

        if (productData.product_sub_main_cat) {
            formData.append("sub_main_cat", productData.product_sub_main_cat);
        }

        if (productData.product_type) {
            formData.append("product_type", productData.product_type); // Append product type
        }

        try {
            const url = selectedProductId
                ? `https://drdprints.com/api/update-product/${selectedProductId}`
                : "https://drdprints.com/api/store-all-products";

            const method = selectedProductId ? "PUT" : "POST";

            const response = await axios({
                method: method,
                url: url,
                data: payload, // Pass the payload as JSON
                headers: {
                    "Content-Type": "application/json", // Set the Content-Type header
                },
            });

            if (response.status === 200 || response.status === 201) {
                setMessage({
                    type: "success",
                    text: `Product ${selectedProductId ? "updated" : "added"} successfully`,
                });
                fetchProductsList();
            } else {
                setMessage({
                    type: "danger",
                    text: "Failed to save product. Please try again.",
                });
            }
        } catch (error) {
            console.error("Error saving product:", error);
            setMessage({
                type: "danger",
                text: "An unexpected error occurred while saving the product.",
            });
        }
    };


    const handleCategoryChange = (e) => {
        const categoryId = e.target.value;
        setSelectedCategoryId(categoryId);

        setProductData({
            ...productData,
            product_category_id: categoryId,
        });

        if (categoryId) {
            const selectedCategory = categories.find((cat) => cat.id === parseInt(categoryId));
            if (selectedCategory) {
                setSubMainCategories(selectedCategory.sub_main_categories || []);
            }
        } else {
            setSubMainCategories([]);
        }

        const filtered = products.filter(
            (product) => product.cat_id === parseInt(categoryId)
        );
        setFilteredProducts(filtered);
    };

    const handleColorChange = (e) => {
        const pd_image_color_id = e.target.value;
        setProductData({ ...productData, pd_image_color_id: pd_image_color_id });

    };

    const handleDealChange = (e) => {
        const selectedDealId = e.target.value;
        setProductData({ ...productData, product_deal_id: selectedDealId });
    };

    const deleteProduct = async (id) => {
        try {
            await axios.delete(
                `https://drdprints.com/api/delete-all-products/${id}`
            );
            setMessage({ type: "success", text: "Product deleted successfully" });
            fetchProductsList();
        } catch (error) {
            console.error("Error deleting product:", error);
            setMessage({ type: "danger", text: "Failed to delete product" });
        }
    };

    const handleInputChange = (e) => {
        setProductData({ ...productData, [e.target.name]: e.target.value });
    };

    const handleArrayInputChange = (e, key, index) => {
        const updatedArray = [...productData[key]];
        updatedArray[index] = e.target.value;
        setProductData({ ...productData, [key]: updatedArray });
    };

    const handleImageChange = (e) => {
        setProductData({ ...productData, [e.target.name]: e.target.files[0] });
    };

    const handleMultipleImageChange = (e) => {
        const files = Array.from(e.target.files);
        setProductData({
            ...productData,
            pd_images: files,
        });
    };

    const handleAddArrayField = (key) => {
        setProductData({ ...productData, [key]: [...productData[key], ""] });
    };

    const handleRemoveArrayField = (key, index) => {
        const updatedArray = [...productData[key]];
        updatedArray.splice(index, 1);
        setProductData({ ...productData, [key]: updatedArray });
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        saveProduct();
    };

    const handleSubCategoryChange = (e) => {
        const selectedSubCatId = e.target.value;
        setProductData({
            ...productData,
            product_subcategory_id: selectedSubCatId,
        });
    };

    const handleAddNew = () => {
        setSelectedProductId(null);
        setProductData({
            title: "",
            desc: "",
            image: null,
            pd_short_desc: "",
            pd_overview_title: "",
            pd_overview_desc: "",
            pd_overview_image: null,
            pd_image_color_id: "",
            pd_images: [],
            pd_size_title: [],
            pd_size_desc: [],
            pd_size_s: [],
            pd_size_l: [],
            pd_size_xl: [],
            pd_size_2xl: [],
            pd_size_3xl: [],
            pd_prices: [],
            faq_title: [],
            faq_desc: [],
        });
        setMessage(null);
    };

    // console.log("productDetails", productDetails);
    return (
        <Container className="py-4">
            <h1 className="text-center mb-4">Product Manager</h1>
            {message && <Alert variant={message.type}>{message.text}</Alert>}

            <Tabs
                id="product-form-tabs"
                activeKey={key}
                onSelect={(k) => setKey(k)}
                className="mb-4"
            >
                <Tab eventKey="general" title="General Info">
                    <Card className="mb-4">
                        <Card.Body>
                            <Form onSubmit={handleSubmit}>
                                <Row className="mb-3">
                                    <Col md={6}>
                                        <Form.Group controlId="formTitle">
                                            <Form.Label>Title</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="title"
                                                value={productData.title} // Dynamically set from productData
                                                onChange={handleInputChange}
                                                placeholder="Enter Title"
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group controlId="formProductType">
                                            <Form.Label>Product Type</Form.Label>
                                            <Form.Control
                                                as="select"
                                                name="product_type"
                                                value={productData.product_type}
                                                onChange={handleInputChange}
                                            >
                                                <option value="">Select Product Type</option>
                                                {types.map((type) => (
                                                    <option key={type.id} value={type.id}>
                                                        {type.title}
                                                    </option>
                                                ))}
                                            </Form.Control>
                                        </Form.Group>
                                    </Col>


                                    <Col md={6}>
                                        <Form.Group controlId="formDesc">
                                            <Form.Label>Description</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="desc"
                                                value={productData.desc}
                                                onChange={handleInputChange}
                                                placeholder="Enter Description"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group controlId="formPdShortDesc">
                                            <Form.Label>Short Description</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="pd_short_desc"
                                                value={productData.pd_short_desc} // Dynamically set from productData
                                                onChange={handleInputChange}
                                                placeholder="Enter Short Description"
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group controlId="formPdOverviewTitle">
                                            <Form.Label>Overview Title</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="pd_overview_title"
                                                value={productData.pd_overview_title}
                                                onChange={handleInputChange}
                                                placeholder="Enter Overview Title"
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group controlId="formPdOverviewDesc">
                                            <Form.Label>Overview Description</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="pd_overview_desc"
                                                value={productData.pd_overview_desc}
                                                onChange={handleInputChange}
                                                placeholder="Enter Overview Description"
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group controlId="formPdImageColorId">
                                            <Form.Label>Image Color ID</Form.Label>
                                            <Form.Control
                                                as="select"
                                                value={productData.pd_image_color_id}
                                                onChange={handleColorChange}
                                            >
                                                <option value="">select Color</option>
                                                {(Colors || []).map((cat) => (
                                                    <option key={cat.id} value={cat.id}>
                                                        {cat.color_name}
                                                    </option>
                                                ))}
                                            </Form.Control>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group controlId="formCategorySelect">
                                            <Form.Label>Select Category</Form.Label>
                                            <Form.Control
                                                as="select"
                                                name="product_category_id"
                                                value={productData.product_category_id}
                                                onChange={handleCategoryChange}
                                            >
                                                <option value="">Select a category</option>
                                                {categories.map((cat) => (
                                                    <option key={cat.id} value={cat.id}>
                                                        {cat.cat_title}
                                                    </option>
                                                ))}
                                            </Form.Control>

                                        </Form.Group>

                                    </Col>
                                    <Col md={6}>
                                        <Form.Group controlId="formSubMainCategorySelect">
                                            <Form.Label>Select Sub Main Category</Form.Label>
                                            <Form.Control
                                                as="select"
                                                value={productData.product_sub_main_cat}
                                                onChange={(e) =>
                                                    setProductData({ ...productData, product_sub_main_cat: e.target.value })
                                                }
                                            >
                                                <option value="">Select a Sub Main Category</option>
                                                {subMainCategories.map((subMain) => (
                                                    <option key={subMain.id} value={subMain.id}>
                                                        {subMain.sub_main_title}
                                                    </option>
                                                ))}
                                            </Form.Control>
                                        </Form.Group>

                                    </Col>
                                    <Col md={6}>
                                        <Form.Group controlId="formSubCategorySelect">
                                            <Form.Label>Select Sub Category</Form.Label>
                                            <Form.Control
                                                as="select"
                                                value={productData.product_subcategory_id || ""}
                                                onChange={(e) =>
                                                    setProductData({ ...productData, product_subcategory_id: e.target.value })
                                                }
                                            >
                                                <option value="">Select a Sub Category</option>
                                                {subcategories.map((sub) => (
                                                    <option key={sub.id} value={sub.id}>
                                                        {sub.cat_sub_title}
                                                    </option>
                                                ))}
                                            </Form.Control>
                                        </Form.Group>





                                    </Col>



                                    <Col md={6}>
                                        <Form.Group controlId="formBusinessToolSelect">
                                            <Form.Label>Select Business Tool</Form.Label>
                                            <Form.Control
                                                as="select"
                                                value={productData.product_BusinessTool_id}
                                                onChange={(e) =>
                                                    setProductData({
                                                        ...productData,
                                                        product_BusinessTool_id: e.target.value,
                                                    })
                                                }
                                            >
                                                <option value="">Select a Business Tool</option>
                                                {businessCards.map((Business) => (
                                                    <option key={Business.id} value={Business.id}>
                                                        {Business.b_card_title}
                                                    </option>
                                                ))}
                                            </Form.Control>
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group controlId="formDealSelect">
                                            <Form.Label>Select Deal</Form.Label>
                                            <Form.Control
                                                as="select"
                                                value={productData.product_deal_id}
                                                onChange={handleDealChange}
                                            >
                                                <option value="">Select a deal</option>
                                                {deals.map((deal) => (
                                                    <option key={deal.id} value={deal.id}>
                                                        {deal.deal_title}
                                                    </option>
                                                ))}
                                            </Form.Control>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Form>
                        </Card.Body>
                    </Card>
                </Tab>
                <Tab eventKey="images" title="Images">
                    <Card className="mb-4">
                        <Card.Body>
                            <Form onSubmit={handleSubmit}>
                                <Row>
                                    <Col md={6}>
                                        <Form.Group controlId="formImage">
                                            <Form.Label>Main Image</Form.Label>
                                            <Form.Control
                                                type="file"
                                                name="image"
                                                onChange={handleImageChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group controlId="formOverviewImage">
                                            <Form.Label>Overview Image</Form.Label>
                                            <Form.Control
                                                type="file"
                                                name="pd_overview_image"
                                                onChange={handleImageChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group controlId="formPdImages">
                                            <Form.Label>Additional Images</Form.Label>
                                            <Form.Control
                                                type="file"
                                                multiple
                                                onChange={handleMultipleImageChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Form>
                        </Card.Body>
                    </Card>
                </Tab>
                <Tab eventKey="pricing" title="Pricing & Sizes">
                    <Accordion>
                        <Accordion.Item eventKey="0">
                            <Accordion.Header>Sizes</Accordion.Header>
                            <Accordion.Body>
                                {/* Dynamic Size Fields */}
                                {[
                                    "pd_size_title",
                                    "pd_size_desc",
                                    "pd_size_s",
                                    "pd_size_l",
                                    "pd_size_xl",
                                    "pd_size_2xl",
                                    "pd_size_3xl",
                                ].map((key) => (
                                    <React.Fragment key={key}>
                                        {productData[key].map((value, index) => (
                                            <Row className="mb-2" key={`${key}-${index}`}>
                                                <Col md={10}>
                                                    <Form.Control
                                                        type="text"
                                                        value={value}
                                                        onChange={(e) =>
                                                            handleArrayInputChange(e, key, index)
                                                        }
                                                        placeholder={`Enter ${key.replace(/_/g, " ")} ${index + 1
                                                            }`}
                                                    />
                                                </Col>
                                                <Col md={2}>
                                                    <Button
                                                        variant="danger"
                                                        onClick={() => handleRemoveArrayField(key, index)}
                                                    >
                                                        Remove
                                                    </Button>
                                                </Col>
                                            </Row>
                                        ))}
                                        <Button
                                            onClick={() => handleAddArrayField(key)}
                                            className="mb-3 mx-1"
                                        >
                                            Add {key.replace(/_/g, " ")}
                                        </Button>
                                    </React.Fragment>
                                ))}
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="1">
                            <Accordion.Header>Prices</Accordion.Header>
                            <Accordion.Body>
                                {productData.pd_prices.map((price, index) => (
                                    <Row className="mb-2" key={`price-${index}`}>
                                        <Col md={10}>
                                            <Form.Control
                                                type="text"
                                                value={price}
                                                onChange={(e) =>
                                                    handleArrayInputChange(e, "pd_prices", index)
                                                }
                                                placeholder={`Enter Price ${index + 1}`}
                                            />
                                        </Col>
                                        <Col md={2}>
                                            <Button
                                                variant="danger"
                                                onClick={() =>
                                                    handleRemoveArrayField("pd_prices", index)
                                                }
                                            >
                                                Remove
                                            </Button>
                                        </Col>
                                    </Row>
                                ))}
                                <Button onClick={() => handleAddArrayField("pd_prices")}>
                                    Add Price
                                </Button>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </Tab>
                <Tab eventKey="faq" title="FAQ">
                    <Card className="mb-4">
                        <Card.Body>
                            <Form>
                                {productData.faq_title.map((title, index) => (
                                    <Row key={`faq-title-${index}`}>
                                        <Col md={10}>
                                            <Form.Control
                                                type="text"
                                                value={title}
                                                onChange={(e) =>
                                                    handleArrayInputChange(e, "faq_title", index)
                                                }
                                                placeholder={`FAQ Title ${index + 1}`}
                                            />
                                        </Col>
                                        <Col md={2}>
                                            <Button
                                                variant="danger"
                                                onClick={() =>
                                                    handleRemoveArrayField("faq_title", index)
                                                }
                                            >
                                                Remove
                                            </Button>
                                        </Col>
                                    </Row>
                                ))}
                                <Button onClick={() => handleAddArrayField("faq_title")} className="mx-1 my-2">
                                    Add FAQ Title
                                </Button>

                                {productData.faq_desc.map((desc, index) => (
                                    <Row key={`faq-desc-${index}`} className="mt-2">
                                        <Col md={10}>
                                            <Form.Control
                                                type="text"
                                                value={desc}
                                                onChange={(e) =>
                                                    handleArrayInputChange(e, "faq_desc", index)
                                                }
                                                placeholder={`FAQ Description ${index + 1}`}
                                            />
                                        </Col>
                                        <Col md={2}>
                                            <Button
                                                variant="danger"
                                                onClick={() =>
                                                    handleRemoveArrayField("faq_desc", index)
                                                }
                                            >
                                                Remove
                                            </Button>
                                        </Col>
                                    </Row>
                                ))}
                                <Button onClick={() => handleAddArrayField("faq_desc")} className="mx-1 my-2">
                                    Add FAQ Description
                                </Button>
                            </Form>
                        </Card.Body>
                    </Card>
                </Tab>
            </Tabs>

            <Button
                variant="primary"
                type="submit"
                onClick={handleSubmit}
                className="w-100 mb-3"
            >
                {selectedProductId ? "Update Product" : "Add Product"}
            </Button>
            {selectedProductId && (
                <Button variant="secondary" onClick={handleAddNew} className="w-100">
                    Add New Product
                </Button>
            )}
            {/* <Row className="my-4"> */}
            {/*     <Col> */}
            {/*         <Form.Group controlId="categoryFilter"> */}
            {/*             <Form.Label>Filter by Category</Form.Label> */}
            {/*             <Form.Control */}
            {/*                 as="select" */}
            {/*                 value={selectedCategoryId} */}
            {/*                 onChange={handleCategoryChange} */}
            {/*             > */}
            {/*                 <option value="">All Categories</option> */}
            {/*                 {categories.map(category => ( */}
            {/*                     <option key={category.id} value={category.id}> */}
            {/*                         {category.cat_title} */}
            {/*                     </option> */}
            {/*                 ))} */}
            {/*             </Form.Control> */}
            {/*         </Form.Group> */}
            {/*     </Col> */}
            {/* </Row> */}

            <h2 className="my-3">Products</h2>
            <Table responsive striped bordered hover>
                <thead>
                    <tr>
                        <th>Title</th>
                        <th>Description</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {paginatedProducts.map((product) => (
                        <tr key={product.id}>
                            <td>{product.title}</td>
                            <td>{product.desc}</td>
                            <td>
                                <Button
                                    variant="primary"
                                    size="sm"
                                    onClick={() => handleProductSelect(product.slug)}
                                >
                                    View Details
                                </Button>{" "}
                                <Button
                                    variant="warning"
                                    size="sm"
                                    className="my-2"
                                    onClick={() => handleProductEdit(product)}
                                >
                                    Edit
                                </Button>
                                <Button
                                    variant="danger"
                                    size="sm"
                                    onClick={() => deleteProduct(product.id)}
                                >
                                    Delete
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            {productDetails && (
                <div>
                    <h3>Product Details: {productDetails.product}</h3>
                    <p>Product Type: {productDetails.product_type || "N/A"}</p>
                    <p>Category: {productDetails.product_category_name || "N/A"}</p>
                    <p>Deal: {productDetails.product_deal_name || "N/A"}</p>
                    <p>Deal Discount: {productDetails.product_deal_discount || "N/A"}</p>

                    {/* Render other product details as needed */}
                    <Tabs
                        id="product-details-tabs"
                        activeKey={key}
                        onSelect={(k) => setKey(k)}
                        className="mb-4"
                    >
                        <Tab eventKey="overview" title="Overview">
                            {productDetails.product_details.map((detail) => (
                                <Card key={detail.id} className="mb-4">
                                    <Card.Body>
                                        <h5>{detail.pd_overview_title}</h5>
                                        <p>{detail.pd_overview_desc}</p>
                                    </Card.Body>
                                </Card>
                            ))}
                        </Tab>
                        <Tab eventKey="prices" title="Prices">
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th>Price</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {productDetails.product_prices.map((price) => (
                                        <tr key={price.id}>
                                            <td>{price.price}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </Tab>
                        <Tab eventKey="images" title="Images">
                            <div className="d-flex flex-wrap">
                                {productDetails.product_images.map((image) => (
                                    <img
                                        key={image.id}
                                        src={`https://drdprints.com/uploads/products/${image.pd_image}`}
                                        alt="Product"
                                        className="m-2"
                                        style={{ width: "150px", height: "150px" }}
                                    />

                                ))}
                            </div>
                        </Tab>
                        <Tab eventKey="faqs" title="FAQs">
                            {productDetails.product_faqs.map((faq) => (
                                <Card key={faq.id} className="mb-4">
                                    <Card.Body>
                                        <h5>{faq.pd_faq_title}</h5>
                                        <p>{faq.pd_faq_desc}</p>
                                    </Card.Body>
                                </Card>
                            ))}
                        </Tab>
                        <Tab eventKey="Size" title="Size">
                            <div className="table-responsive">
                                <table className="table table-bordered text-center">
                                    <thead>
                                        <tr>
                                            <th>Size</th>
                                            <th>S</th>
                                            {/* <th>M</th> */}
                                            <th>L</th>
                                            <th>XL</th>
                                            <th>2XL</th>
                                            <th>3XL</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {productDetails.product_sizes.map((Size) => (
                                            <React.Fragment key={Size.id}>
                                                <tr>
                                                    <td>Length (A)</td>
                                                    <td>{Size.pd_size_s}</td>
                                                    {/* <td>{Size.pd_size_m}</td> */}
                                                    <td>{Size.pd_size_l}</td>
                                                    <td>{Size.pd_size_xl}</td>
                                                    <td>{Size.pd_size_2xl}</td>
                                                    <td>{Size.pd_size_3xl}</td>
                                                </tr>
                                                <tr>
                                                    <td>Width (B)</td>
                                                    <td>{Size.pd_size_s}</td>
                                                    {/* <td>{Size.pd_size_m}</td> */}
                                                    <td>{Size.pd_size_l}</td>
                                                    <td>{Size.pd_size_xl}</td>
                                                    <td>{Size.pd_size_2xl}</td>
                                                    <td>{Size.pd_size_3xl}</td>
                                                </tr>
                                            </React.Fragment>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </Tab>
                    </Tabs>
                </div>
            )}

            {/* Pagination Controls */}
            <Pagination>
                <Pagination.First
                    onClick={() => handlePageChange(1)}
                    disabled={currentPage === 1}
                />
                <Pagination.Prev
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                />
                {Array.from({ length: totalPages }, (_, index) => (
                    <Pagination.Item
                        key={index + 1}
                        active={index + 1 === currentPage}
                        onClick={() => handlePageChange(index + 1)}
                    >
                        {index + 1}
                    </Pagination.Item>
                ))}
                <Pagination.Next
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                />
                <Pagination.Last
                    onClick={() => handlePageChange(totalPages)}
                    disabled={currentPage === totalPages}
                />
            </Pagination>
        </Container>
    );
};

export default ProductsPage;
